import { Plus, Trash2 } from "lucide-react";
import { HUD } from "./theme";

const inputCls = `h-10 rounded-xl px-3 text-sm border ${HUD.input}`;

export const ContactTypesSection = ({ f, setF }) => {
  const list = f.contact_types || [];
  const set = (i, k, v) => setF({ ...f, contact_types: list.map((t, j) => (j === i ? { ...t, [k]: v } : t)) });
  return (
    <div className={`${HUD.panel} p-5 space-y-4`} data-testid="jarvis-contact-types-section">
      <div>
        <h3 className="text-white font-['Outfit'] text-lg">Customer types & auto discounts</h3>
        <p className="text-xs text-gray-400 mt-1">Every contact gets a type. New invoices for that type get this discount automatically (you can still change it per invoice). Contractors are billed directly; note the car owner on the invoice.</p>
      </div>
      {list.map((t, i) => (
        <div key={t.id || i} className="flex flex-wrap items-center gap-2" data-testid={`jarvis-ctype-${t.id || i}`}>
          <input value={t.label} onChange={(e) => set(i, "label", e.target.value)} data-testid={`jarvis-ctype-label-${i}`} className={`${inputCls} flex-1 min-w-[160px]`} />
          <div className="flex items-center gap-1">
            <input type="number" min="0" max="100" value={t.discount_pct ?? 0} onChange={(e) => set(i, "discount_pct", Number(e.target.value))} data-testid={`jarvis-ctype-discount-${i}`} className={`${inputCls} w-24`} />
            <span className="text-xs text-gray-400">% off</span>
          </div>
          {t.id === "customer" ? <span className="w-4" /> : (
            <button onClick={() => setF({ ...f, contact_types: list.filter((_, j) => j !== i) })} className="text-gray-500 hover:text-rose-300" data-testid={`jarvis-ctype-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          )}
        </div>
      ))}
      <button onClick={() => setF({ ...f, contact_types: [...list, { label: "New type", discount_pct: 0 }] })} className={`${HUD.ghost} h-9 px-3 text-xs flex items-center gap-1`} data-testid="jarvis-ctype-add"><Plus className="w-3.5 h-3.5" /> Add type</button>
    </div>
  );
};
